import React from "react";

function DateAndTimeChip(props) {
  return <div className="date-and-time-chip">{props.date}</div>;
}

export default DateAndTimeChip;
